import React from "react";
import styled from "styled-components";
import ServerTile from "./ServerTile";
import { useCopyToClipboard } from "@uidotdev/usehooks";

const GridContainer = styled.section`
  display: flex;
  margin-top: 1.5625em;
  width: 100%;
  align-items: start;
  gap: 1em;
  justify-content: start;
  @media (max-width: 991px) {
    max-width: 100%;
  }
`;

const ServersArea = styled.div`
  min-width: 15em;
  width: 100%;
  flex: 1;
  flex-shrink: 1;
  flex-basis: 0%;
  @media (max-width: 991px) {
    max-width: 100%;
  }
`;

const ServersContent = styled.div`
  display: flex;
  align-items: start;
  gap: 1em;
  justify-content: start;
`;

const ServersContainer = styled.div`
  display: flex;
  width: 100%;
  align-items: start;
  gap: 1em;
  justify-content: center;
  flex-wrap: wrap;
`;

const ServerGrid = ({ serversList }) => {
  const [copiedText, copyToClipboard] = useCopyToClipboard();

  const handlePlay = (server) => {
    window.location = `steam://connect/${server.IP}:${server.Port}`;
  };

  const handleCopy = (server) => {
    copyToClipboard(`${server.IP}:${server.Port}`);
  };

  return (
    <GridContainer>
      <ServersArea>
        <ServersContent>
          <ServersContainer>
            {serversList.map((server) => (
              <ServerTile
                key={server.ID}
                serverNumber={server.ID}
                countryCode={server.CountryCode.toUpperCase()}
                flagSrc={`https://flagsapi.com/${server.CountryCode.toUpperCase()}/flat/64.png`}
                onPlay={() => handlePlay(server)}
                onCopy={() => handleCopy(server)}
              />
            ))}
          </ServersContainer>
        </ServersContent>
      </ServersArea>
    </GridContainer>
  );
};

export default ServerGrid;
